import { render, staticRenderFns } from "./WsFlexGallery.vue?vue&type=template&id=31c44e44&"
import script from "./WsFlexGallery.vue?vue&type=script&lang=js&"
export * from "./WsFlexGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports